import { Component, inject } from '@angular/core';
import { ToastNotificationService } from '../core/toast-notification.service';
import { UIBlockingService } from '../core/ui-blocking.service';
import { MemberAdService } from './member-ad.service';
import { AdUploadResult } from './DTOs/file-upload-result';
import { MemberAdRequest } from './DTOs/member-ad-request';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AdType } from './DTOs/AdTypes';

@Component({
    selector: 'app-submit-member-ad',
    templateUrl: './submit-member-ad.component.html',
    providers: [UIBlockingService]

})
export class SubmitMemberAdComponent {
    constructor(private memberAdService: MemberAdService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService,
        private route: ActivatedRoute,
        private router: Router) { }

    adImage: File = null;
    preview = "";
    submitPressed = false;
    memberNotes = "";
    adUrl = "";
    runDate;
    runDateParsed: Date;
    adTypes: AdType[] = [];
    selectedAdTypeId: number = -1;
    imageTypes = ['image/jpeg', 'image/png', 'image/webp'];
    maxAdFileSize = 75000; // 75 KB
    disabledSubmitButton = false;
    invalidRun = false;
    invalidDate = false;
    invalidSelectedAd = false;
    groupType = 1;

    get selectedAdType() {
        return this.adTypes.find(t => t.type == this.selectedAdTypeId) ?? new AdType();
    }


    ngOnInit() {
        this.route.params.subscribe(params => {
            var groupType = +params['adtype'];
            this.groupType = groupType;
            this.getAdTypeDetails(groupType);
        });
    }

    getAdTypeTooltip(type) {
        switch (type) {
            case 1:
                return '8,000 general business/civic subscribers, sent weekly';
            case 2:
                return '8,500 general business/civic subscribers, sent monthly';
            case 3:
                return 'Ad displays for 30 days in the Indy Chamber Member Directory';
            case 4:
                return 'No longer in use';
            case 5:
                return '11,000 economic development subscribers, sent monthly';
            case 6:
                return 'Run Weekly During Legislative Session and Monthly After Session';
            case 7:
                return 'Ad displays for 30 days on the Indy Chamber Events Calendar page';
            case 8:
                return 'Ad displays for 30 Days on the Indy Chamber News page';
            default:
                return 'Select ad type to see more details here.';
        }
    }

    getAdTypeDetails(groupType: number) {
        this.blockUI.start();
        this.memberAdService.getAdTypeDetails(groupType).subscribe({
            next: (data) => {
                this.adTypes = data;
            },
            error: (err) => {
                this.notificationService.error(err.message);
                this.blockUI.stop();
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
            }
        });
    }

    updateAdImage(files: FileList) {
        if (!this.imageTypes.includes(files.item(0).type)) {
            this.notificationService.error("File is not a recognized image type.")
            this.disabledSubmitButton = true;
            return;
        }
        if (files.item(0).size > this.maxAdFileSize) {
            this.notificationService.error("File is larger than the maximum file size.");
            this.disabledSubmitButton = true;
            return;
        }
        this.disabledSubmitButton = false;
        this.adImage = files.item(0);
        const reader = new FileReader();

        reader.onload = (e: any) => {
            this.preview = e.target.result;
        }
        reader.readAsDataURL(files.item(0));
    }

    submitAd() {

        this.runDateParsed = this.parseDate(this.runDate);
        if (this.selectedAdType.type < 0) {
            this.invalidSelectedAd = true;
        }
        else {
            this.invalidSelectedAd = false;
        }
        if (this.invalidDate || this.runDateParsed == null) {
            this.invalidDate = false;
            this.invalidRun = true;
        }
        else {
            this.invalidDate = false;
            this.invalidRun = false
        };
        if (this.invalidSelectedAd || this.invalidRun) return;
        if (this.adImage == null) return;
        var url = URL.createObjectURL(this.adImage);
        var img = new Image;


        var checkAdForSize = (width: number, height: number) => {
            this.submitPressed = true;

            var dimensions = this.selectedAdType.sizeRequirement.split('x').map(x => parseInt(x));
            if (width != dimensions[0] || height != dimensions[1]) {
                this.notificationService.error(`Ad dimensions do not match chosen type.\nSubmitted Ad dimensions: ${width}x${height}`);
                return;
            }

            this.blockUI.start();
            this.uploadFile()
                .subscribe({
                    next: (data: AdUploadResult) => {
                        this.submitMemberAd(data.fileStorageId);
                    },
                    error: (err) => {
                        console.log(err);
                        this.notificationService.error(err.message);
                        this.blockUI.stop();
                    }
                });
        }
        img.onload = function () {
            //this.begin(img.width, img.height);
            checkAdForSize(img.width, img.height);
            URL.revokeObjectURL(img.src);
        };

        img.src = url;
    }



    submitMemberAd(adImageId: string) {
        if (this.runDateParsed == null)
            return;
        let req = new MemberAdRequest(adImageId, this.memberNotes, this.selectedAdType.type, this.adUrl, this.runDateParsed);
        this.memberAdService.submitMemberAd(req)
            .subscribe({
                next: (data) => {
                    console.log('Observable emitted the next value: ' + data);
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    console.log('Observable emitted the complete notification');
                    this.notificationService.success("Successfully submitted ad");
                    this.blockUI.stop();
                    this.router.navigate(['/admin-portal/member/member-ads/']);
                }
            });
    }

    uploadFile() {
        const uploadData = new FormData();
        uploadData.append('mainImage', this.adImage, this.adImage.name);
        return this.memberAdService.uploadAdFile(uploadData);
    }

    getSizeDisplay(size: string) {
        var dimensions = size.split('x');
        return `${dimensions[0]}px by ${dimensions[1]}px`;
    }
    parseDate(dateString: string) {
        if (!dateString) {
            return null;
        }
        const formats = [
            /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
            /^\d{2}\/\d{2}\/\d{4}$/, // MM/DD/YYYY
            /^\d{2}-\d{2}-\d{4}$/, // MM-DD-YYYY
            /^\d{2}.\d{2}.\d{4}$/, // MM.DD.YYYY
        ];

        let date: Date;

        for (const format of formats) {
            if (format.test(dateString)) {
                if (format === formats[0]) { // YYYY-MM-DD
                    date = new Date(dateString);
                } else if (format === formats[1]) { // MM/DD/YYYY
                    const [month, day, year] = dateString.split('/').map(Number);
                    date = new Date(year, month - 1, day);
                } else if (format === formats[2]) { // MM-DD-YYYY
                    const [month, day, year] = dateString.split('-').map(Number);
                    date = new Date(year, month - 1, day);
                } else if (format === formats[3]) { // MM.DD.YYYY
                    const [month, day, year] = dateString.split('.').map(Number);
                    date = new Date(year, month - 1, day);
                }

                break;
            }
        }
        if (!date || isNaN(date.getTime())) {
            this.invalidDate = true;
        }

        return date;
    }

}
